import { Component, Input, OnInit } from '@angular/core';
import { texts } from './candidate-experience.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-experience',
  templateUrl: './candidate-experience.component.html',
  styleUrls: ['./candidate-experience.component.scss']
})
export class CandidateExperienceComponent implements OnInit {

  texts = texts;

  @Input()
  candidate : any;
  
  constructor() { }

  ngOnInit() {
  }

}
